module.exports = __webpack_public_path__ + "img/bo.24408e4.svg";